import ArrowCircleRight from './assets/arrow-circle-right.svg'
import UpFill from './assets/up-fill.svg'

export const outlineIcons = {
  UpFill,
  ArrowCircleRight,
} as const

export type OutlineIconName = keyof typeof outlineIcons
